const ITEMS = [
  {
    id: 'napit',
    img: 'https://storage.readdy-site.link/project_files/00423dcc-69f9-4748-ac0c-c15d54e5586b/9bc56e1c-c07f-4db6-91cd-f5510ba9d877_NAPIT-approved-electrician-JW.png?v=4961e5aeb5ff6d1a936eb371b395fafd',
    label: 'NAPIT Approved',
    darkBg: false,
  },
  {
    id: 'partp',
    img: 'https://storage.readdy-site.link/project_files/00423dcc-69f9-4748-ac0c-c15d54e5586b/8539f92b-69d1-4ddc-9763-1df0e0a0a1e5_part-p-electrical-safety.png?v=660b0f165dc42f73a075a378d0500fe1',
    label: 'Part P Certified',
    darkBg: false,
  },
  {
    id: 'mcs',
    img: 'https://storage.readdy-site.link/project_files/00423dcc-69f9-4748-ac0c-c15d54e5586b/78abe9ed-8987-42f4-91c6-41c8ae94223e_MCSCertifiedMark_BLACK_RGB_0_0.png?v=f3b4e52c5a9e4592e7269f189833916b',
    label: 'MCS Certified',
    darkBg: false,
  },
  {
    id: 'ws1',
    img: 'https://storage.readdy-site.link/project_files/00423dcc-69f9-4748-ac0c-c15d54e5586b/63fb1dd3-f85d-4d0d-8acd-3d3779044e21_WhatsApp-Image-2024-10-09-at-18.56.48.jpeg?v=0e96c0ee8c3cacd982f2e22beecdaaa6',
    label: 'Accredited',
    darkBg: true,
  },
  {
    id: 'ws2',
    img: 'https://storage.readdy-site.link/project_files/00423dcc-69f9-4748-ac0c-c15d54e5586b/27e21d6a-1119-4f0d-bf35-de72216b01b0_WhatsApp-Image-2024-10-09-at-18.56.53.jpeg?v=4e76b22b2d3f485e3eb0b223d2985fe5',
    label: 'Certified',
    darkBg: true,
  },
];

// Duplicate for seamless infinite loop
const TRACK = [...ITEMS, ...ITEMS];

function Badge({ item }: { item: (typeof ITEMS)[0] }) {
  return (
    <div className="flex-shrink-0 flex items-center gap-3 mx-3 cursor-default select-none group">
      {item.img ? (
        <div
          className={`flex items-center justify-center rounded-xl px-4 py-2 transition-all duration-300 group-hover:scale-105 ${
            item.darkBg
              ? 'bg-transparent'
              : 'bg-white shadow-sm'
          }`}
          style={{ minWidth: 90, height: 56 }}
        >
          <img
            src={item.img}
            alt={item.label}
            className="h-10 max-w-[110px] object-contain"
            style={
              item.darkBg
                ? { filter: 'drop-shadow(0 0 6px rgba(200,169,106,0.5)) brightness(1.05)' }
                : { filter: 'none' }
            }
          />
        </div>
      ) : (
        <div
          className="flex items-center gap-2.5 px-5 py-3 rounded-full border border-[#C8A96A]/25 bg-white/3 hover:border-[#C8A96A]/50 transition-all duration-300"
          style={{ minWidth: 90 }}
        >
          {item.icon && (
            <div className="w-7 h-7 flex items-center justify-center rounded-full bg-[#C8A96A]/15 flex-shrink-0">
              <i className={`${item.icon} text-[#C8A96A] text-sm`} />
            </div>
          )}
          <span className="text-[#E0C78A] text-sm font-semibold whitespace-nowrap">{item.label}</span>
        </div>
      )}
    </div>
  );
}

export default function TrustedBy() {
  return (
    <section className="bg-[#071120] py-10 relative overflow-hidden">
      {/* Top gold line */}
      <div
        className="absolute top-0 left-0 w-full h-px"
        style={{ background: 'linear-gradient(90deg, transparent, #C8A96A60, transparent)' }}
      />
      {/* Bottom gold line */}
      <div
        className="absolute bottom-0 left-0 w-full h-px"
        style={{ background: 'linear-gradient(90deg, transparent, #C8A96A60, transparent)' }}
      />

      {/* Left + right fade masks */}
      <div
        className="absolute left-0 top-0 h-full w-28 z-10 pointer-events-none"
        style={{ background: 'linear-gradient(90deg, #071120, transparent)' }}
      />
      <div
        className="absolute right-0 top-0 h-full w-28 z-10 pointer-events-none"
        style={{ background: 'linear-gradient(270deg, #071120, transparent)' }}
      />

      {/* Label */}
      <p className="text-center text-[#C8A96A]/60 text-xs tracking-[0.25em] uppercase font-medium mb-6">
        Accredited &amp; Trusted By
      </p>

      {/* Scrolling track */}
      <div className="overflow-hidden relative">
        <div
          className="flex items-center"
          style={{ animation: 'marqueeScroll 32s linear infinite', width: 'max-content' }}
        >
          {TRACK.map((item, idx) => (
            <Badge key={`${item.id}-${idx}`} item={item as typeof ITEMS[0]} />
          ))}
        </div>
      </div>
    </section>
  );
}
